import Breadcrumb from "../SharedComponents/components/Breadcrumb/Breadcrumb";
import SellerLayout from "./components/SellerLayout";
import RightArrowIconSVG from "../SharedComponents/assets/icons/svg/RightArrowIconSVG";
import NewNotifications from "./components/NotificationComponents/NewNotifications";
import OldNotifications from "./components/NotificationComponents/OldNotifications";

const NotificationsPage = () => {
    const breadcrumbs = [
        { title: "Početak", href: "/home" },
        { title: "Obaveštenja" }
    ];

    return (
        <SellerLayout>
            <div style={styles.breadcrumbWrapper}>
                <div style={styles.arrowIcon}>
                    <RightArrowIconSVG />
                </div>
                <Breadcrumb
                    title={"Obaveštenja"}
                    breadcrumbs={breadcrumbs}
                />
            </div>
            <NewNotifications />
            <OldNotifications />
        </SellerLayout>
    );
};

export default NotificationsPage;

const styles = {
    breadcrumbWrapper: {
        display: "flex"
    },
    arrowIcon: {
        filter: 'brightness(0) saturate(100%)',
        scale: "80%",
        rotate: "180deg",
        paddingTop: "35px"
    }
};
